import { takeEvery } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as authSaga from "../sagas/authSaga";
export function* rootSaga() {
	yield takeEvery(
		actionTypes.UPDATE_SELECTED_LANGUAGE,
		authSaga.updateSelectedLanguage
	);
}
